export const AssetStatus = {
  UNKNOWN: 0,
  ACTIVE: 1,
  DISABLED: 2,
  STANDBY: 3,
  MAINTENANCE: 4,
}
